import { InvoiceStatusEnum } from '@fora-monorepo/employer-my-pages-common/types';

import { TypedTFunction } from '../../i18n/i18n';

export const getStatusText = (status: InvoiceStatusEnum | null, t: TypedTFunction): string => {
  switch (status) {
    case InvoiceStatusEnum.Reminded:
      return t('list.invoiceEvents.eventReminded');
    case InvoiceStatusEnum.DebtCollection:
      return t('list.invoiceEvents.eventDebtCollection');
    case InvoiceStatusEnum.InstallmentPlan:
      return t('status.invoiceInstallmentPlan.tagText');
    case InvoiceStatusEnum.PaymentDeferral:
      return t('list.invoiceEvents.eventPaymentDeferral');
    case InvoiceStatusEnum.Disputed:
      return t('status.invoiceDisputed.tagText');
    case InvoiceStatusEnum.Paid:
      return t('status.invoicePaid.tagText');
    case InvoiceStatusEnum.NoStatus:
    default:
      return '';
  }
};
